<template>
  <!-- 采购方管理 -->
  <div class="page-container">
    <div v-if="!isComponent">
      <div class="page_title">
        <div class="page_title_desc">采购方管理</div>
      </div>
      <el-divider></el-divider>
      <!--工具栏-->
      <div class="toolbar">
        <el-form :inline="true" :model="filterForm" :size="size">
          <el-form-item label>
            <el-input v-model="filterForm.purchaseName" placeholder="请输入采购方名称" clearable></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input v-model="filterForm.contactName" placeholder="请输入联系人" clearable></el-input>
          </el-form-item>
          <el-form-item label>
            <el-select v-model="filterForm.status" placeholder="状态" filterable clearable>
              <el-option
                v-for="item in statusList"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-search"
              label="搜索"
              perms="-1"
              type="primary"
              @click="handlerSearch"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-share"
              label="重置"
              perms="-1"
              @click="handleReset"
              type="primary"
            />
          </el-form-item>
        </el-form>
      </div>
      <!--表格树内容栏-->
      <el-table v-loading="loading" :data="purchaserList" stripe size="mini" style="width: 100%;">
        <el-table-column type="index" width="50" align="center" fixed label="序号"></el-table-column>
        <el-table-column prop="purchaseName" align="center" label="名称"></el-table-column>
        <el-table-column prop="contactName" align="center" label="联系人"></el-table-column>
        <el-table-column prop="contactPhone" align="center" label="联系手机号"></el-table-column>
        <el-table-column prop="loginPhone" align="center" label="登录手机号"></el-table-column>
        <el-table-column prop="statusDesc" align="center" label="状态"></el-table-column>
        <el-table-column width="150" fixed="right" align="left" label="操作">
          <template slot-scope="scope">
            <kt-button
              label="查看"
              perms="-1"
              type="text"
              v-if="scope.row.status == 0"
              @click="checkComponent(scope.row)"
            />
            <kt-button
              label="审核通过"
              perms="-1"
              type="text"
              v-if="scope.row.status == 2"
              @click="handleCheck(scope.row, true)"
            />
            <kt-button
              label="审核驳回"
              perms="-1"
              type="text"
              v-if="scope.row.status == 2"
              @click="handleCheck(scope.row, false)"
            />
            <kt-button
              label="修改名称"
              perms="30300"
              type="text"
              v-if="scope.row.status != 4"
              @click="handleChangeName(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding:20px;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float:right;"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="isShowChangeDialog" v-if="isShowChangeDialog"
      title="修改名称"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="500px">
        <el-form :model="nameForm" label-width="120px" label-position="left" size="small">
          <el-form-item label="原采购方名称：">
            <span>{{ currentRow.purchaseName }}</span>
          </el-form-item>
          <el-form-item label="新采购方名称：">
            <el-input v-model="nameForm.newName" placeholder="请输入新采购方名称" clearable style="width: 200px;"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" >
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <!--查看详情-->
    <PurDetail
      v-if="isComponent"
      :purchaseParentNo="purchaseParentNo"
      :coalMineNo="coalMineNo"
      @backFun="detailFun"
    />
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import PurDetail from "./PurDetail";

export default {
  components: {
    KtButton,
    PurDetail
  },
  data() {
    return {
      purchaseParentNo: "", // 采购方编号唯一
      coalMineNo: "", // 煤矿编号
      isComponent: "",
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      purchaserList: [],
      loginPhoneList: [],
      dialogVisible: false,
      selectCoalCategory: [],
      purchaseList: [], // 采购方名称下拉框
      contactNameList: [], // 联系人名称下拉框
      statusList: [],
      filterForm: {
        purchaseName: "",
        contactName: "",
        loginPhone: "",
        coalCategoryNo: "",
        multipleBookingFlag: "",
        approvalSet: "",
        status: ""
      },
      isShowChangeDialog: false,
      nameForm: {

      }
    };
  },
  mounted() {
    this.getPetPurchaserList();
    // this.getAllPurchaseList(); // 获取采购方列表
    // this.selectList(); // 获取联系人列表
    this.getStatusList(); // 获取状态
  },
  methods: {
    // 获取所有采购方手机号
    async getStatusList() {
      let res = await this.$api.purchaser.mGetStatusList();
      this.statusList = !res.data ? [] : res.data;
    },
    //查看采购方详情
    checkComponent(val) {
      this.purchaseParentNo = val.purchaseParentNo;
      this.isComponent = true;
    },
    detailFun(val) {
      this.isComponent = val;
      this.getPetPurchaserList();
    },
    // 获取采购方列表
    getPetPurchaserList() {
      const _t = this;
      _t.loading = true;
      const params = {
        pageNo: _t.pageNo,
        pageSize: _t.pageSize
      };

      let index = 0;
      for (let key in _t.filterForm) {
        const val = _t.filterForm[key];
        if (val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          params["searchFieldList[" + index + "].singleValue"] = val;
          index++;
        }
      }
      _t.$api.purchaser.getNewPurchaserList(params).then(res => {
        _t.loading = false;
        if (res.code === "0") {
          const data = res.data;
          if (data.dtoList && data.dtoList.length > 0) {
            _t.purchaserList = data.dtoList;
            _t.totalSize = data.totalSize;
          } else {
            _t.purchaserList = [];
          }
        }
      });
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getPetPurchaserList();
    },
    // 搜索
    handlerSearch() {
      this.pageNo = 1;
      this.getPetPurchaserList();
    },
    // 重置
    handleReset() {
      this.filterForm = {
        purchaseName: "",
        contactName: "",
        loginPhone: "",
        coalCategoryNo: "",
        multipleBookingFlag: "",
        approvalSet: "",
        status: ""
      };
      this.pageNo = 1;
      this.getPetPurchaserList();
    },
    // 禁用启用
    handleCheck(row, isApproal) {
      let confirmMsg = "是否确认审核通过";
      if (!isApproal) {
        confirmMsg = "是否确认驳回该申请";
      }
      this.$confirm(confirmMsg, "提示", {
        type: "warning"
      }).then(async () => {
        const params = {
          approvalResult: isApproal ? 0 : 1,
          purchaseParentNo: row.purchaseParentNo
        };
        await this.$api.purchaser.mNewApprovalPurchaser(params);

        this.$message({ message: "操作成功", type: "success" });
        this.getPetPurchaserList();
      });
    },
    // 获取采购方列表
    async getAllPurchaseList() {
      let res = await this.$api.purchaser.mGetNewAllPurchaseList();
      if (res.data && res.data.length) {
        this.purchaseList = res.data;
      } else {
        this.purchaseList = [];
      }
    },
    // 获取联系人列表
    async selectList() {
      let res = await this.$api.purchaser.mGetNewSelectList();
      if (res.data && res.data.length) {
        let contactNameList = res.data.filter(item => item.name);
        this.contactNameList = contactNameList;
      } else {
        this.contactNameList = [];
      }
    },
    handleChangeName(row){
      this.currentRow = row
      this.isShowChangeDialog = true
    },
    dialogCloseCallback(){
      this.nameForm = {}
    },
    handleCancel(){
      this.isShowChangeDialog = false
      this.nameForm = {}
    },
    async handleConfirm() {
      if(!this.nameForm.newName){
        this.$message({
          type: 'error',
          message: '请输入新采购方名称',
          offset: 200
        })
        return
      }
      let res = await this.$api.purchaser.updatePurchaserName({
        purchaseParentNo: this.currentRow.purchaseParentNo,
        purchaseParentName: this.nameForm.newName
      })
      this.$message({
        type: 'success',
        message: '采购方名称修改成功',
        offset: 200
      })
      this.isShowChangeDialog = false
      this.getPetPurchaserList()
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

.addressMap {
  width: 100%;
  height: 200px;
  margin-top: 20px;
}
</style>
